import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Stack, StackProps, SvgIconProps, Typography, TypographyProps } from '@mui/material';

type LoadingIndicatorProps = {
    isLoading: boolean;
    color?: TypographyProps['color'] & SvgIconProps['color'];
    loadingMessage?: React.ReactNode;
    loadingSx?: StackProps['sx'];
    children?: React.ReactNode;
};

export const LoadingIndicatorIcon = ({
    isLoading,
    color = 'info',
    loadingMessage,
    loadingSx,
    children = null,
}: LoadingIndicatorProps) => {
    return (
        <>
            {isLoading ? (
                <Stack
                    component="span"
                    direction="row"
                    data-testid="loading-indicator"
                    sx={{ alignItems: 'center', ...loadingSx }}
                >
                    <AutorenewIcon
                        color={color}
                        sx={{
                            minWidth: '24px',
                            animation: 'spin 1.5s infinite linear',
                            '@keyframes spin': {
                                '0%': {
                                    transform: 'rotate(0deg)',
                                },
                                '100%': {
                                    transform: 'rotate(360deg)',
                                },
                            },
                        }}
                    />
                    {loadingMessage && (
                        <Typography component="span" color={color}>
                            {loadingMessage}
                        </Typography>
                    )}
                </Stack>
            ) : (
                <>{children}</>
            )}
        </>
    );
};
